import React from 'react';
import corebank from '../Images/corebank.jpg';

function CoreBank() {
    const services = [
        { title: 'Locker', desc: 'Safe Locker Deposit Lockers to the customers' },
        { title: 'Loans', desc: 'Different options to customers according to their preference' },
        { title: 'Deposit', desc: 'Provides you a complete banking convenience' },
        { title: 'Fund Transfer', desc: 'Unique and customizable mobile banking and payments' },
    ];

    return (
        <div className="py-5" style={{ backgroundColor: '#f7f9fc' }}>
            <div className="container">
                <div className="row align-items-center g-4">
                    {/* Left Side Content */}
                    <div className="col-md-5">
                        <h3 className="mb-3 text-danger">Services</h3>
                        <p>We Offer Products And Services For Your <strong>Personal And Professional Banking Needs</strong>.</p>
                        <p style={{ fontSize: "15px", color: "#555" }}>
                            Minimum amount of deposit for opening a saving deposit account is Rs. 100. The money can be withdrawn by using withdrawal slip in the concerned branches. Saving account is of continuing nature. There is no maximum period.
                        </p>
                        <div className="mt-3">
                            <button className="btn btn-outline-danger me-2">View More</button>
                            <button className="btn btn-danger">Contact Us</button>
                        </div>
                    </div>

                    {/* Right Side Grid Cards */}
                    <div className="col-md-7">
                        <div className="row g-3">
                            {services.map((service, index) => (
                                <div className="col-6" key={index}>
                                    <div
                                        className="p-3 h-100 rounded shadow-sm"
                                        style={{
                                            backgroundColor: index % 2 === 0 ? '#e74c3c' : '#ffffff',
                                            color: index % 2 === 0 ? '#fff' : '#333',
                                            border: '1px solid #ccc',
                                            minHeight: '110px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <h6 className="fw-bold mb-1">{service.title}</h6>
                                        <p className="mb-0" style={{ fontSize: "14px" }}>{service.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CoreBank;
